import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-900 text-stone-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_iv-medics-clinic/artifacts/46lyldln_Blue%20Green%20Modern%20Medical%20Centre%20Logo_20260215_170034_0000.png"
                alt="IV Medics & Diagnostic Clinic Logo"
                className="w-12 h-12 rounded-full object-contain bg-white"
              />
              <div>
                <span className="font-[Outfit] font-bold text-white text-base block">
                  IV Medics
                </span>
                <span className="text-xs text-stone-400">& Diagnostic Clinic</span>
              </div>
            </div>
            <p className="text-sm text-stone-400 leading-relaxed">
              Your trusted healthcare partner in Ibadan. Quality medical care, infection treatment, and comprehensive diagnostics.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-[Outfit] font-semibold text-white text-sm mb-4">Quick Links</h4>
            <nav className="space-y-2">
              {[
                { label: "Our Services", href: "/#services" },
                { label: "Testimonials", href: "/#testimonials" },
                { label: "About Us", href: "/#about" },
                { label: "Contact", href: "/#contact" },
              ].map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="block text-sm text-stone-400 hover:text-green-400 transition-colors"
                >
                  {link.label}
                </a>
              ))}
              <Link
                to="/book"
                className="block text-sm text-green-400 hover:text-green-300 font-medium transition-colors"
              >
                Book Appointment
              </Link>
              <Link
                to="/careers"
                className="block text-sm text-green-400 hover:text-green-300 font-medium transition-colors"
              >
                Careers
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-[Outfit] font-semibold text-white text-sm mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2 text-sm">
                <MapPin className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
                <span>No Prof 3 Olu Longe Street, Off Lekan Salami Estate, Bodija, Ibadan</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <Phone className="w-4 h-4 text-green-500 flex-shrink-0" />
                <div>
                  <a href="tel:09162731000" className="hover:text-green-400 transition-colors block">09162731000</a>
                  <a href="tel:09162741000" className="hover:text-green-400 transition-colors block">09162741000</a>
                </div>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <Mail className="w-4 h-4 text-green-500 flex-shrink-0" />
                <a href="mailto:info@ivmedicsclinic.com" className="hover:text-green-400 transition-colors">
                  info@ivmedicsclinic.com
                </a>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-[Outfit] font-semibold text-white text-sm mb-4">Operating Hours</h4>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-sm">
                <Clock className="w-4 h-4 text-green-500 flex-shrink-0" />
                <span>Open 24/7</span>
              </div>
              <p className="text-sm font-medium text-white ml-6">24 Hours, 7 Days a Week</p>
            </div>
            <div className="mt-6">
              <a
                href="https://wa.me/2349162731000"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm bg-green-700/20 text-green-400 rounded-full px-4 py-2 hover:bg-green-700/30 transition-colors"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                  <path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492a.5.5 0 00.611.611l4.458-1.495A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-2.398 0-4.608-.842-6.337-2.245l-.442-.37-3.092 1.037 1.037-3.092-.37-.442A9.954 9.954 0 012 12C2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z"/>
                </svg>
                Chat on WhatsApp
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-stone-800 mt-12 pt-8 text-center">
          <p className="text-xs text-stone-500">
            &copy; {currentYear} IV Medics and Diagnostics Clinic. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
